import React from "react";
import ReusableDataTable from "../../hooks/ReusableDataTable";
import { Button, Label, Modal, TextInput, Avatar, Select, } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import '../../style/model.css';
import { FaPen } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import useInputValidation from "../../hooks/useInputValidation";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import axios from "axios";
import { useSidebar } from "../../context/SidebarOpenContext";

function Line() {
    const [AddModal, setAddModal] = useState(false);
    const [EditModal, setEditModal] = useState(false);
    const [DeleteModal, setDeleteModal] = useState(false);
    const [Input, setInput] = useState({});
    const [Line, setLine] = useState({});
    const { errors, handleChange, resetErrors } = useInputValidation();
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    useEffect(() => {
        fetchmarker();
    }, []);


    const onChangeValue = (e) => {
        handleChange(e);
        setInput({ ...Input, [e.target.name]: e.target.value });
    }

    const fetchmarker = async () => {
        try {
            const response = await axios.get("master/lines");
            const lineData = response.data;
            setLine(lineData);
        } catch (error) {
            console.error("Error fetching Line data:", error);
        }
    };

    const addMarker = async (event) => {
        event.preventDefault();
        try {
            axios
                .post(`master/lines`, {
                    line_name: Input.line_name,
                })
                .then((res) => {
                    if (res.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Line  Created",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        setAddModal(false);
                        fetchmarker();


                    } else if (res.data.success === 2) {
                        Swal.fire({
                            icon: "error",
                            text: "Line  already exists...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }

    };

    const UpdateMarker = async (event) => {
        event.preventDefault();

        try {
            axios
                .put(`master/lines/${Input.id}`, {
                    line_name: Input.line_name,
                })
                .then((res) => {
                    if (res.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Details Updated",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        setEditModal(false);
                        fetchmarker();
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }

    };

    const deletMarker = async () => {
        try {
            axios.delete(`master/lines/${Input.id}`).then((res) => {
                if (res.data.success === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "Line  deleted",
                        type: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    fetchmarker();
                    setDeleteModal(false);
                } else {
                    Swal.fire({
                        icon: "error",
                        text: "Server Problem. Please Try Again...",
                        type: "error",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                }
                return;
            });
        } catch (error) {
            throw error;
        }
    };


    const data = Array.isArray(Line)
        ? Line.map((M) => ({
            id: M.line_id,
            line_name: M.line_name,
            option: (<div style={{ display: "flex" }}>
                <FaPen className="text-amber-400 text-xl" onClick={() => {
                    setEditModal(true); setInput({
                        id: M.line_id,
                        line_name: M.line_name,
                    });
                }} />
                <MdDeleteForever className="ml-2 text-red-500 text-2xl" onClick={() => { setDeleteModal(true); setInput({ id: M.line_id }) }} />
            </div>)
        }))
        : [];


    const columns = [
        { name: "S.No", selector: (row, index) => index + 1, sortable: true },
        { name: "Line", selector: (row) => row.line_name, sortable: true },
        { name: "Option", selector: (row) => row.option },
    ];

    return (

        <div className={` ${isSidebarOpen ? "p-4 sm:ml-64 bg-content-bg min-h-screen " : "p-4  bg-content-bg min-h-screen"}  `} >
            <div className="p-4 rounded-lg dark:border-gray-700  mt-14">
                <div className="p-4 rounded-lg shadow bg-white">
                    <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" onClick={() => setAddModal(true)} >Add Line</Button>
                    <ReusableDataTable
                        title="Line List"
                        columns={columns}
                        data={data}
                    />
                </div>
            </div>

            <Modal show={AddModal} size="md" onClose={() => { setAddModal(false); resetErrors(); }} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Add Line</h3>
                        <form onSubmit={addMarker}>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.line_name && "failure"} value="Line" />
                                </div>
                                <TextInput
                                    id="line_name"
                                    name="line_name"
                                    placeholder=""
                                    type="text"
                                    color={errors.line_name && "failure"}
                                    helperText={
                                        errors.line_name && (
                                            <>
                                                <span className="font-medium"></span> {errors.line_name}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}
                                    pattern="^[A-Za-z0-9\s]*$"
                                    required
                                />
                            </div>
                           
                            <div className="pt-2 w-full flex justify-center">
                                <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" type="submit">Submit</Button>
                                <Button className="ml-2" color="gray" onClick={() => { setAddModal(false); resetErrors(); }}>
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={EditModal} size="md" onClose={() => { setEditModal(false); resetErrors(); }} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Update Line</h3>
                        <form onSubmit={UpdateMarker}>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.line_name && "failure"} value="Size" />
                                </div>
                                <TextInput
                                    id="line_name"
                                    name="line_name"
                                    placeholder=""
                                    type="text"
                                    color={errors.line_name && "failure"}
                                    helperText={
                                        errors.line_name && (
                                            <>
                                                <span className="font-medium"></span> {errors.line_name}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}
                                    pattern="^[A-Za-z0-9\s]*$"
                                    required
                                    value={Input.line_name}
                                />
                            </div>
                            
                            <div className="pt-2 w-full flex justify-center">
                                <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" type="submit">Submit</Button>
                                <Button className="ml-2" color="gray" onClick={() => { setEditModal(false); resetErrors(); }}>
                                    Cancel
                                </Button>
                            </div>
                        </form>

                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={DeleteModal} size="md" onClose={() => setDeleteModal(false)} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="text-center">
                        <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                            Are you sure you want to delete this Line?
                        </h3>
                        <div className="flex justify-center gap-4">
                            <Button color="failure" onClick={() => deletMarker()}>
                                {"Yes"}
                            </Button>
                            <Button className="ml-2" color="gray" onClick={() => setDeleteModal(false)}>
                                No
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </div>


    );
}

export default Line;
